module.exports = __webpack_public_path__ + "media/assets/icons/ribbon-2aa3d29222b28aa70f888423c37ce6d6.svg";